module.exports = "/_next/static/images/managedServicesDataCenters-7542f1eaebcdd6dc10386508d36fa581.webp";